export function updateRecordReduction<T>(array: T[], record: T, index: number): T[] {
    return [...array.slice(0, index), record, ...array.slice(index + 1)];
}
